"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initData = void 0;
const fetch_1 = require("./libs/fetch");
const util_1 = require("./libs/util");
const ua_1 = require("./libs/ua");
let config = [];
const urlParams = util_1.getUrlParams();
async function initData() {
    const data = await getWujiData();
    const { lang = "en" } = urlParams;
    const targetData = data.filter(({ lang: _lang }) => _lang.split(",").find((item) => item === lang));
    if (targetData) {
        config = processWujiData(targetData);
    }
    return config;
}
exports.initData = initData;
async function getWujiData() {
    var _a;
    const url = fetch_1.getWujiUrl({
        schemaid: "download_page",
        schemakey: "b0f8e8a4a6b44b838479de1550d6410b",
        filter: encodeURIComponent(`lang=${urlParams.lang}&platform="${((_a = ua_1.uaResult === null || ua_1.uaResult === void 0 ? void 0 : ua_1.uaResult.os) === null || _a === void 0 ? void 0 : _a.isMobile) ? "m" : "pc"}"`),
    });
    try {
        const { data, code } = (await fetch_1.get({ url, withCredentials: false }));
        if (code !== 200) {
            return null;
        }
        return data;
    }
    catch (e) {
        return null;
    }
}
//根据平台获取下载链接地址
function getDownloadLinkByPlatform(downloadLink) {
    const downloadLinkArr = downloadLink.split("$");
    const isIOS = /(iphone)|(ipod)|(iPad)/i.test(navigator === null || navigator === void 0 ? void 0 : navigator.userAgent);
    let downloadLinkRes = "";
    if (isIOS) {
        downloadLinkRes = downloadLinkArr[1] || downloadLinkArr[0];
    }
    else {
        downloadLinkRes = downloadLinkArr[0];
    }
    //动态参数占位替换
    const replaceKeys = downloadLinkRes.match(/%([^%]+)%/g);
    if (replaceKeys === null || replaceKeys === void 0 ? void 0 : replaceKeys.length) {
        replaceKeys.forEach((itemKey) => {
            let urlParamsTarget = urlParams[`${itemKey.replace(/%/g, "")}`];
            if (urlParamsTarget) {
                downloadLinkRes = downloadLinkRes.replace(itemKey, `${itemKey.replace(/%/g, "")}=${urlParamsTarget}`);
            }
        });
    }
    //获取配置动作
    if (downloadLinkRes.indexOf("##action=") > -1) {
        const action = downloadLinkRes === null || downloadLinkRes === void 0 ? void 0 : downloadLinkRes.split("##action=")[1];
        if (action === "jump") {
            return location.replace(downloadLinkRes.replace(new RegExp(`\#\#action=${action}`), ""));
        }
    }
    return downloadLinkRes;
}
function processWujiData(data) {
    return data
        .map((config) => {
        const { bg_image: bgImage, download_link, _id, download_text: downloadText } = config, rest = __rest(config, ["bg_image", "download_link", "_id", "download_text"]);
        return Object.assign(Object.assign({}, rest), { bgImage: (bgImage === null || bgImage === void 0 ? void 0 : bgImage.split("\n")) || [""], downloadLink: getDownloadLinkByPlatform(download_link), downloadText });
    })
        .sort((config1, config2) => config1.index - config2.index);
}
